/**
 * Tracks whether the user has navigated within the app since the page loaded.
 * Used by BackButton to distinguish "came from external link" (flag false →
 * go to Home) from "navigated in-app" (flag true → go back normally).
 * Reset only on full page reload — that's intentional.
 *
 * _ready is set by markNavigationReady() (called from NavigationContainer's
 * onReady). The initial URL resolution fires onStateChange BEFORE onReady, so
 * any state-change that arrives while _ready is false is the one-time
 * bootstrap navigation — not a real user action — and must be skipped.
 */
let _navigated = false
let _ready = false

export function markNavigationReady(): void {
  _ready = true
}

export function markInAppNavigation(): void {
  if (!_ready) return
  _navigated = true
}

export function hasNavigatedInApp(): boolean {
  return _navigated
}
